<template>
  <div>
    <div class="soluBanner">
      <Carousel :bannerUrl="bannerUrl"></Carousel>
    </div>
    <!-- 协会介绍 -->
    <div class="assoBox padd_top_30">
      <div class="park_enterprise">
        <div class="commpany">
          <div class="commpany_img">
            <img :src="enterDetails.thumbnailPath" alt="" />
          </div>
          <div class="commpany_text">
            <p class="commpany_Title">{{ enterDetails.name }}</p>
            <p class="commpany_meg">{{ enterDetails.summary }}</p>
            <div class="commpany_btn" @click="goToAssdetailes(enterDetails)">
              查看更多 >
            </div>
          </div>
        </div>
      </div>
    </div>
      <!-- 业务范围 -->
    <BusinessUnit></BusinessUnit>
    <!-- 会员单位 -->
    <Member :memberList="memberList"></Member>
    <!-- 协会动态 -->
    <Dynamics :newList="newList"></Dynamics>
    <!-- 协会简报 -->
    <Brief :briefList="briefList" v-if="briefList.length>0"></Brief>
  </div>
</template>

<script>
// 轮播
import Carousel from "../carousel/carousel";
// 业务范围
import BusinessUnit from "./components/businessUnit";
// 会员单位
import Member from "./components/member";
// 协会动态
import Dynamics from "./components/dynamics";

// 协会简报
import Brief from "./components/brief";

import {
  getEnterpriseMangeList,
  getBannerList,
  queryNewText
} from "../../utils/interface";
// 协会会员列表
import {
  associationInfo, briefProTable,
  memberProTable,
} from "../../utils/associationApi";
import { mapState } from "vuex";

export default {
  name: "association",
  metaInfo: {
      title: "水泵协会-为会员企业提供资源共享、高质量多形式的信息化服务", // set a title
      meta: [
        {
          // set meta
          name: "keywords",
          content:
            "水泵云|盐湖区水泵协会|水泵产业升级|盐湖区水泵特色专业镇|水泵协会|水泵协会组织",
        },
        {
          // set meta
          name: "description",
          content:
            "水泵协会旨在聚集行业资源、搭建资源共享与合作平台，为行业会员企业提供会员管理、会议管理、项目管理及行业数据等一站式信息化服务。",
        },
      ],
    },
  components: { Carousel,BusinessUnit,Member,Dynamics,Brief },
  data() {
    return {
      // 查询条件
      bannerUrl: [],
      newList: [],
      briefList: [],
      memberList: [],
      current: 0,
      pageSize: 7,
      setIn: null,
      enterDetails: {},
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        //banner图
        this.getIndexVocationalWork();
            // 重点企业‘」’’
        this.getEnterpriseMangeList();
        // 新闻
        this.getSolutionList();
        // 会员列表
        this.memberProTableList();
        // 简报列表
        this.briefProTableList();

      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // banner图片
    getIndexVocationalWork() {
      getBannerList({
        groupCode: "AssociationBanner",
      })
        .then((res) => {
          this.bannerUrl = res;
        })
        .catch(function(error) {});
    },

    //   协会介绍查看更多
    goToAssdetailes(items) {
      let routeData = this.$router.resolve({
        name: "introduction",
      });
      window.open(routeData.href, "_blank");
    },
    // 协会介绍
    getEnterpriseMangeList() {
      associationInfo("SBXH").then((res) => {
        this.enterDetails = res;
      });
    },
    // 会员列表
    memberProTableList() {
      let params = {
        current: 1,
        pageSize: 10,
      }
      memberProTable(params).then((res) => {
        if (res.success) {
          this.memberList = res.data;
        }
      });
    },
    // 简报
    briefProTableList(){
      let params = {
        status: 1,
        current: 1,
        pageSize: 5,
      }
      briefProTable(params).then((res) => {
        this.briefList = res.list;
      });
    },
    // 新闻
    getSolutionList() {
      let params = {
        status: "PUBLISH",
        origin: "ASSOCIATION",
        current: 1,
        pageSize: 4,
      };
      queryNewText(params).then((res) => {
        if (res.success) {
          this.newList = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.soluBanner {
  width: 100%;
}
// 重点企业
.assoBox {
  padding-bottom: 40px;

  .park_enterprise {
    margin-top: 30px;
    width: 1200px;
    margin: 0 auto;
    .commpany {
      display: flex;
      font-size: 16px;

      .commpany_text {
        width: 50%;
        margin-top: 14px;
        margin-left: 40px;
        position: relative;
      }

      .commpany_Title {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .commpany_meg {
        font-size: 14px;
        line-height: 30px;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 8;
        -webkit-box-orient: vertical;
      }

      .commpany_btn {
        position: absolute;
        bottom: 0;
        left: 0;
        border: 1px solid #009999;
        border-radius: 5px;
        padding: 4px 20px;
        font-size: 12px;
        color: #3A3A3C;
        cursor: pointer;
      }

      .commpany_img {
        width: 600px;
        height: 360px;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/association/index.vue